<template lang="">
  <div class="thankcover">
    <div class="journey-top-right" v-if="journeyId">
      <JourneyIdContainer :journey-id="journeyId" label="Reference Number :" />
    </div>
    <div class="thank-you">
      <div class="text-center">
        <img src="/images/paymentFailed.gif" class="m-auto" />
        <h4 class="text-center text-danger">Payment Failed</h4>
        <p class="text-center">Please Retry</p>
        <button type="button" class="btn commonButton mt-5" @click="retryPayment">
          Retry Payment
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  DIY_CHECK_PATH,
  PAYMENT_GATEWAY_REDIRECTED_STORAGE_KEY,
  PAYMENT_STATUS_OUTCOME_STORAGE_KEY,
  PAYMENT_URL_STORAGE_KEY,
} from '@/lib/payment/payment-status-constants';

export default {
  data() {
    return {
      journeyId: '',
    };
  },
  mounted() {
    if (sessionStorage.getItem('journey_id')) {
      this.journeyId = JSON.parse(sessionStorage.getItem('journey_id'));
    } else if (this.$route.query.journeyId) {
      this.journeyId = this.$route.query.journeyId;
    }
  },
  methods: {
    retryPayment() {
      sessionStorage.removeItem(PAYMENT_STATUS_OUTCOME_STORAGE_KEY);
      sessionStorage.removeItem(PAYMENT_GATEWAY_REDIRECTED_STORAGE_KEY);
      let paymentUrl = null;
      try {
        const raw = sessionStorage.getItem(PAYMENT_URL_STORAGE_KEY);
        paymentUrl = raw ? JSON.parse(raw) : null;
      } catch {
        paymentUrl = null;
      }
      if (paymentUrl) {
        sessionStorage.setItem(PAYMENT_GATEWAY_REDIRECTED_STORAGE_KEY, 'true');
        window.location.href = paymentUrl;
        return;
      }
      const query = {};
      if (this.journeyId) {
        query.journeyId = this.journeyId;
      }
      this.$router.push({ path: DIY_CHECK_PATH, query });
    },
  },
};
</script>
<style lang="scss">
@import '../../assets/scss/components/Loaders.scss';

.journey-top-right {
  position: fixed;
  top: 88px;
  right: 24px;
  z-index: 1000;
  padding: 6px 10px;
  background: transparent;
}

@media (max-width: 768px) {
  .journey-top-right {
    top: 72px;
    right: 12px;
    max-width: calc(100vw - 24px);
  }
}
</style>
